import { createFileRoute } from '@tanstack/react-router';

import { Synchronisation } from '@/features/documentation/synchronisation';

export const Route = createFileRoute('/_app/docs/sync')({
  component: Synchronisation,
});
